export const ACTION_GET_RESULTS_MONTHLY_CHART = "ACTION_GET_RESULTS_MONTHLY_CHART";
export const ACTION_GET_RESULTS_WEEKLY_CHART = "ACTION_GET_RESULTS_WEEKLY_CHART";
export const ACTION_GET_RESULTS_ANNUAL_CHART = "ACTION_GET_RESULTS_ANNUAL_CHART";
export const ACTION_GET_RESULTS_HAPPINESS = "ACTION_GET_RESULTS_HAPPINESS";
